const STORAGE_KEY = "bainocular.thanksgivingConfiguration";
const SELECTED_INTERVAL_KEY = "bainocular.thanksgivingSelectedInterval";

const EMPTY_CONFIG = {
  interval: "2",
  hours: "2",
  fromDate: "",
  toDate: "",
  ricefIds: [],
  distributionIds: [],
  senderEmail: [],
};

function normalizeIdList(values) {
  if (!Array.isArray(values)) return [];
  return values.map((value) => String(value ?? "").trim()).filter(Boolean);
}

function normalizeConfig(config) {
  const interval = String(config?.interval ?? config?.hours ?? "2").trim() || "2";
  return {
    interval,
    hours: interval,
    fromDate: typeof config?.fromDate === "string" ? config.fromDate.trim() : "",
    toDate: typeof config?.toDate === "string" ? config.toDate.trim() : "",
    ricefIds: normalizeIdList(config?.ricefIds),
    distributionIds: normalizeIdList(config?.distributionIds),
    senderEmail: normalizeIdList(config?.senderEmail),
  };
}

function migrateLegacyConfig(parsed) {
  if (Array.isArray(parsed)) {
    return parsed.map(normalizeConfig);
  }

  if (parsed && typeof parsed === "object") {
    if (Array.isArray(parsed.ricefIds) || Array.isArray(parsed.distributionIds)) {
      return [normalizeConfig(parsed)];
    }
  }

  return [];
}

export function loadThanksgivingConfigCache() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    return migrateLegacyConfig(JSON.parse(raw));
  } catch {
    return [];
  }
}

/** Backward-compatible single-config read for monitoring page */
export function loadThanksgivingConfig() {
  const configs = loadThanksgivingConfigCache();
  const selectedInterval = getSelectedInterval();
  const matched =
    findConfigByInterval(configs, selectedInterval) ||
    configs[0] ||
    normalizeConfig(EMPTY_CONFIG);

  return {
    ...matched,
    hours: matched.interval,
    rows: [],
  };
}

export function getSelectedInterval() {
  try {
    const raw = localStorage.getItem(SELECTED_INTERVAL_KEY);
    return raw ? String(raw).trim() : "2";
  } catch {
    return "2";
  }
}

export function setSelectedInterval(interval) {
  localStorage.setItem(SELECTED_INTERVAL_KEY, String(interval ?? "").trim());
}

export function findConfigByInterval(configs, interval) {
  const target = String(interval ?? "").trim();
  if (!target || !Array.isArray(configs)) return null;
  return configs.find((item) => String(item.interval).trim() === target) || null;
}

export function saveThanksgivingConfigCache(configs) {
  const normalized = Array.isArray(configs) ? configs.map(normalizeConfig) : [];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  return normalized;
}

export function upsertThanksgivingConfigCache(config) {
  const current = loadThanksgivingConfigCache();
  const nextConfig = normalizeConfig(config);
  const index = current.findIndex(
    (item) => String(item.interval).trim() === String(nextConfig.interval).trim()
  );

  if (index >= 0) {
    current[index] = { ...current[index], ...nextConfig };
  } else {
    current.push(nextConfig);
  }

  return saveThanksgivingConfigCache(current);
}
